var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCalnderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.06177 6.08868H13.3059",
    stroke: "#097E52",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95483 1V3.25933",
    stroke: "#097E52",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40601 1V3.25933",
    stroke: "#097E52",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0921 2.08521H4.27564C2.25669 2.08521 1 3.2114 1 5.27841V11.4589C1 13.5534 2.25669 14.7002 4.27564 14.7002H10.0853C12.1042 14.7002 13.3609 13.574 13.3609 11.5069V5.24409C13.3678 3.2114 12.1111 2.08521 10.0921 2.08521Z",
    stroke: "#097E52",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCalnderIcon);
export default __webpack_public_path__ + "static/media/greenCalnderIcon.21df947b79fb1d8fec28f2e1ae210333.svg";
export { ForwardRef as ReactComponent };